import { Card as MuiCard, CardProps as MuiCardProps, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { dividerColor, warningColor } from 'src/data/colors';

interface CardProps extends Omit<MuiCardProps, 'ref'> {
  children: React.ReactNode;
  showPriority?: boolean;
  className?: string;
}

interface StylesProps {
  showPriority?: boolean;
}

const useStyles = makeStyles<Theme, StylesProps>(() => ({
  container: ({ showPriority }) => ({
    border: showPriority ? `1px solid ${warningColor}` : `1px solid ${dividerColor}`,
    width: '100%',
    '& .MuiCardContent-root': {
      padding: 16,
    },
  }),
}));

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, showPriority, className = '', ...props }, ref) => {
    const classes = useStyles({ showPriority });
    return (
      <MuiCard
        variant="outlined"
        className={`${classes.container} ${className}`}
        ref={ref}
        {...props}
      >
        {children}
      </MuiCard>
    );
  }
);
